import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store';
import CheckAuthorization from './utilities/auth/checkAuthorization';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <CheckAuthorization />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);